import { createContext, useContext } from 'react';
import type { AppLocales } from '@hub/common';

export type StartFlowApi = {
  active: boolean;
  setLocale: (locale: AppLocales) => void;
  end: () => void;
};

export const StartFlowContext = createContext<StartFlowApi>({
  active: false,
  setLocale: () => undefined,
  end: () => undefined,
});

export const useStartFlow = (): StartFlowApi => useContext(StartFlowContext);
